import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * PageTransition — an ivory curtain that sweeps across when route changes.
 * Uses two overlapping panels for a smooth in/out sweep.
 */
export default function PageTransition() {
  const location = useLocation();
  const [state, setState] = useState("idle"); // idle | in | out
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setState("in");
    const t1 = setTimeout(() => setState("out"), 700);
    const t2 = setTimeout(() => setState("idle"), 1500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [location.pathname]);

  if (state === "idle") return null;

  return (
    <div
      data-testid="page-transition"
      aria-hidden
      className="fixed inset-0 z-[9997] pointer-events-none"
      style={{
        background: "#0A0A08",
        transformOrigin: state === "in" ? "bottom" : "top",
        transform: state === "in" ? "scaleY(1)" : "scaleY(0)",
        transition: "transform 0.75s cubic-bezier(0.76, 0, 0.24, 1)",
      }}
    />
  );
}
